// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mPGRp","label":"styles_label__3tIfF"};